import { useBusinessUpdate } from "../../hooks/api/v2/business/useBusinessUpdate";
import { useSupplierRelationshipUpdate } from "../../hooks/api/v2/supplierRelationship/useSupplierRelationshipUpdate";

export type DeliveryInstructionsType = {
  deliveryInstructions: string;
};

export const useUpdateBusinessDeliveryInstructions = (businessId?: number) => {
  const businessUpdateMutation = useBusinessUpdate(businessId);
  return {
    updateBusinessDeliveryInstructions: ({
      data,
      onSuccess,
      onError,
    }: {
      data: DeliveryInstructionsType;
      onSuccess?: () => void;
      onError?: () => void;
    }) => {
      return businessUpdateMutation.mutate(data, { onSuccess, onError });
    },
    isLoading: businessUpdateMutation.isPending,
  };
};

export const useUpdateConnectionDeliveryInstructions = (
  connectionId?: number,
) => {
  const connectionUpdate = useSupplierRelationshipUpdate(connectionId ?? 0);
  return {
    updateConnectionDeliveryInstructions: ({
      data,
      onSuccess,
      onError,
    }: {
      data: DeliveryInstructionsType;
      onSuccess?: () => void;
      onError?: () => void;
    }) => {
      return connectionUpdate.mutate(data, { onSuccess, onError });
    },
    isLoading: connectionUpdate.isPending,
  };
};
